"use client";

import { useTeamsControllerFindAll } from "@dc/gateway-jsonapi";
import { keepPreviousData } from "@tanstack/react-query";
import { useOrganization } from "@/hooks/useOrganization";

interface UseTeamsByOrganizationOptions {
  sort?: string;
  pageNumber?: number;
  pageSize?: number;
  organizationId?: string; // Optional override for specific organization
}

// Hook to fetch teams filtered by the currently selected organization
export function useTeamsByOrganization(options?: UseTeamsByOrganizationOptions) {
  // Use currentOrganizationId for immediate response to org changes (from localStorage)
  // instead of currentOrganization?.id which waits for API response
  const { currentOrganizationId } = useOrganization();
  const { sort = "name", pageNumber, pageSize = 500, organizationId: overrideOrgId } = options ?? {};

  // Use override organization ID only if it's a valid string, otherwise use current user's organization
  const organizationId = overrideOrgId && typeof overrideOrgId === "string" ? overrideOrgId : currentOrganizationId;

  const queryParams = {
    include: "scope" as const,
    sort,
    page: {
      number: pageNumber,
      size: pageSize,
    },
    filter: organizationId ? { "scope.parent.organization.id": organizationId } : undefined,
  };

  const result = useTeamsControllerFindAll(queryParams, {
    query: {
      enabled: !!organizationId,
      placeholderData: keepPreviousData,
    },
  });

  return {
    ...result,
    organizationId,
  };
}
